import React from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { Icon } from 'components';
import Page from 'containers/Page';

export default function Unauthorized() {
  return (
    <Page>
      <Stack
        alignSelf="center"
        justify="center"
        alignItems="center"
        justifyContent="center"
        bg="white.default"
        borderRadius={4}
        spacing={4}
        shadow={4}
        p={6}>
        <Icon
          name="user-lock"
          size="6xl"
        />
        <Text
          variant="2xLargeBold">Oops
        </Text>
        <Text variant="mediumSemiBold">Você não tem permissão pra realizar essa ação!</Text>
      </Stack>
    </Page>
  );
}
